import type { SingleAvailableOpportunity } from '@ps/web-sports-api-types';
import type { BettableOpportunities, PlaceBetResp } from '@ps/web-sports-types';

import type { Entity } from '../entities';
import { errorView } from '../events';
import type { TrackingContextValue } from '../providers/TrackingContext';
import { GAEvent } from '../utils';

import { createMultipleEntities } from './createMultipleEntities';
import { createSingleEntities } from './createSingleEntities';

interface BetPlacedErrorProps {
  response: PlaceBetResp;
  bettableOpportunities: BettableOpportunities;
  opportunities: SingleAvailableOpportunity[];
}

export const betPlacementError = (
  context: TrackingContextValue,
  { response, bettableOpportunities, opportunities }: BetPlacedErrorProps
): void => {
  const entities: Entity[] = [
    ...createSingleEntities(bettableOpportunities.SINGLE),
    ...createMultipleEntities(opportunities)(bettableOpportunities.MULTIPLE)
  ];

  context.entities = entities;

  if (response.respCode) {
    GAEvent({ action: response.respCode }, context);
    errorView({ errorCode: response.respCode }, context);
  }

  response.result?.forEach((result) => {
    GAEvent({ action: result.resultCode }, context);
    errorView({ errorCode: result.resultCode }, context);

    result.runners?.forEach((runner) => {
      if (runner.failureCode) {
        GAEvent({ action: runner.failureCode }, context);
        errorView({ errorCode: runner.failureCode }, context);
      }
    });
  });
};
